export function adjustFrameHeight () {
  const mainPage = document.getElementById('main-page')
  const height = mainPage?.offsetHeight || 835
  window.parent.postMessage({
    frameHeight: height
  }, '*')
}
